import { Transform, Type } from "class-transformer";
import { DatabaseUser } from "src/modules/database/shared/database-user.entity";
import { DateOnly } from "src/modules/sm-base/models/date-only.model";
import { Calendar } from "./Calendar";
import { ProjectField } from "./ProjectField";
import { ProjectType } from "./ProjectType";
import { CustomInitializer } from "src/modules/sm-base/shared/custom-initializer.interface";
import { CalendarEvent } from "./CalendarEvent";
import { CalendarEventStartRelativeTo } from "./CalendarEventStartRelativeTo";
import { Dates } from "src/modules/utils/shared/dates";

export class Project implements CustomInitializer {
    //netgen start
    projectNumber: string;
    title: string;
    typeId: number = null;
    @Type(() => ProjectType)
    type: ProjectType;
    @Transform(({ value }) => typeof value === "string" ? DateOnly.parse(value) : value)
    startDate: DateOnly;
    @Transform(({ value }) => typeof value === "string" ? DateOnly.parse(value) : value)
    deliveryDate1: DateOnly;
    @Transform(({ value }) => typeof value === "string" ? DateOnly.parse(value) : value)
    deliveryDate2: DateOnly;
    @Transform(({ value }) => typeof value === "string" ? DateOnly.parse(value) : value)
    deliveryDate3: DateOnly;
    description: string;
    finished = false;
    @Type(() => Calendar)
    calendar: Calendar;
    calendarId = 0;
    structurePaths: string[];
    contactPersonId = 0;
    @Type(() => ProjectField)
    customFields: ProjectField[];
    @Type(() => Date)
    creationDate: Date;
    createdBy: string;
    @Type(() => Date)
    modifyDate: Date;
    modifiedBy: string;
    id = 0;
    //netgen end

    customInitializer(): void {
        this.structurePaths ??= [];
        this.customFields ??= [];
    }

    getHtmlTitle(withProjectNumber = false): string {
        let s = this.title;
        if (withProjectNumber) {
            s += " <span style='pointer-events: none; color: $00ffff; font-size: smaller'>[" + this.projectNumber + "]</span>";
        }
        if (this.finished) {
            s = "<span style='pointer-events: none; text-decoration: line-through'>" + s + "</span>";
        }
        return s;
    }

    isDeleteAllowed(user: DatabaseUser): boolean {
        return user.isAdmin;
    }

    getEventStartDate(startRelativeTo: CalendarEventStartRelativeTo, startRelativeDays: number, startRelativeToEventId: number, onlyWeekdays: boolean, events: CalendarEvent[]): Date {
        let date: Date = null;
        if (startRelativeTo != null) {
            switch (startRelativeTo) {
                case CalendarEventStartRelativeTo.startDate:
                    date = this.startDate.toDate();
                    break;
                case CalendarEventStartRelativeTo.deliveryDate1:
                    date = (this.deliveryDate1 ?? this.startDate).toDate();
                    break;
                case CalendarEventStartRelativeTo.deliveryDate2:
                    date = (this.deliveryDate2 ?? this.startDate).toDate();
                    break;
                case CalendarEventStartRelativeTo.deliveryDate3:
                    date = (this.deliveryDate3 ?? this.startDate).toDate();
                    break;
                case CalendarEventStartRelativeTo.task:
                    let startRelativeToEvent = events.find(e => e.id == startRelativeToEventId);
                    if (startRelativeToEvent != null) {
                        date = startRelativeToEvent.startDate;
                    }
                    break;
            }
        }
        return date != null ? Dates.add(date, onlyWeekdays ? "weekDay" : "day", startRelativeDays) : null;
    }
}
